exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3jxeA > div {\n  margin: 0 auto 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"spinner": "_3jxeA"
};